var Packery = require('packery');

var s,
  packery = {};
var Masonry = {
  settings: {
    productPageGrid: '.grid-product',
    productPageElement: '.grid-product-item',
    productPageElementText: '.grid-product-item__text'
  },
  init: function() {
    s = this.settings;
    var that = this;

    this.setItemStandardHeight()
      .then(function(data) {
        packery.product = that.initProductGrid();
      })
      .catch(err => {
        console.log(error);
      });

    $(window).bind('resize', function() {
      that.rebuildPackery();
    });
  },
  initProductGrid: function() {
    return new Packery(s.productPageGrid, {
      itemSelector: s.productPageElement,
      percentPosition: true,
      isResizeBound: false
    });
  },

  rebuildPackery: function() {
    var that = this;
    packery.product.destroy();
    $('.grid-product-item').css('height', 'auto');

    this.setItemStandardHeight()
      .then(function(data) {
        // console.log(data);
        // Masonry.triggerLayoutEvent(masonry.product);
        packery.product = that.initProductGrid();
        // console.log('leggo');
        // console.log(masonry.product.packer.spaces)
      })
      .catch(err => {
        console.log(err);
      });
  },

  getItemStandardHeight: function() {
    //return biggest height of text element
    var gridEl = $(s.productPageElementText);
    var maxHeight = 0;

    if (gridEl.length) {
      $.each(gridEl, function() {
        maxHeight = $(this).outerHeight() > maxHeight ? $(this).outerHeight() : maxHeight;
      });
      return Math.ceil(maxHeight);
    }

    return false;
  },

  setItemStandardHeight: function() {
    // returns PROMISE, sets biggest height of text element

    var that = this;
    return new Promise(function(resolve, reject) {
      // console.log(that.getItemStandardHeight());
      if (that.getItemStandardHeight()) {
        $(s.productPageElement).css('height', $(window).width() < 991 ? 'auto' : that.getItemStandardHeight());
        console.log($(window).width() < 991 ? 'auto' : that.getItemStandardHeight());
        $('.grid-rect-1x2, .grid-rect-2x2').css(
          'height',
          $(window).width() < 991 ? 'auto' : that.getItemStandardHeight() * 2
        );
        resolve('Elements have been resized according to the tallest text element.');
      } else {
        reject('no items found');
      }
    });
  }
};

module.exports = Masonry;
// exports.setItemStandardHeight = function(){

// };

// exports.initProductGrid = function(){

// };

// exports.triggerLayoutEvent = function(msnry) {
// don't proceed if masonry has not been initialized
// if ( !msnry ) {
//     return;
// }
// msnry.layout();
// };
// exports.initProviderFeatured = function(item){
//
// };



// WEBPACK FOOTER //
// ./public/src/js/Masonry.js